import React, { useRef } from 'react';
import './Banner.css';
import bannerImage from './assets/banner.jpg';
import maghil from './assets/fone.png';

import g1 from './assets/r1.webp';
import g2 from './assets/r2.webp';
import g3 from './assets/r3.webp';
import g4 from './assets/r4.webp';

const Banner = () => {
  const sliderRef = useRef(null);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: -300,
        behavior: 'smooth'
      });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: 300,
        behavior: 'smooth'
      });
    }
  };

  const locations = [
   
    {
      id: 1,
      name: "Parsippany, NJ",
      address: "296 US-46",
      city: "Parsippany, NJ 07054",
      phone: "+1 (973) 396-8666",   
      hours: "10 AM - 9 PM",
      image: g2
    },
    {
      id: 2,
      name: "Suwanee, GA",
      address: "3230 Caliber St Suit # C101",
      city: "Suwanee, GA 30024",
      phone: "+1 (470) 867-0888",
      hours: "6 AM - 11 PM",
      image: g3
    },
    {
      id: 3,
      name: "Bensalem, PA",
      address: "2163 Galloway Rd",
      city: "Bensalem, PA 19020",
      phone: "+1 (215) 975-0070",
      hours: "11 AM - 12 AM",
      image: g4
    },
    {
      id: 4,
      name: "Madison, WI",
      address: "429 Commerce Dr",
      city: "Madison, WI 53719",
      phone: "+1 (608) 821-3362",
      hours: "11 AM - 10 PM",
      image: g1
    }
  ];

  const handleLocationClick = (locationId) => {
    if (locationId === 1) {
      window.open('https://rajniparsippany.maghildemo.com/', '_blank');
    } else {
      console.log(`Location ${locationId} clicked - no navigation implemented yet`);
    }
  };

  return (
    <section className="banner">
      <div 
        className="banner-background"
        style={{
          backgroundImage: `url(${bannerImage})`
        }}
      ></div>
      
      <div className="banner-overlay">
        <div className="banner-content">
          <p className="banner-slogan">
            We are passionate about bringing you the most authentic Indian dining experience
          </p>
 
          <div className="location-cards" ref={sliderRef}>
            {locations.map((location) => (
              <div 
                key={location.id}
                className="location-card"
                onClick={() => handleLocationClick(location.id)}
              >
                <img 
                  src={location.image} 
                  alt={location.name} 
                  className="location-image" 
                />
                <h3 className="location-name">{location.name}</h3>
                <p className="location-address">{location.address}</p>
                <p className="location-city">{location.city}</p>
                <p className="location-phone">{location.phone}</p>
              </div>
            ))}
          </div>
          
          {/* Navigation Arrows - Mobile Only */}
          <div className="slider-navigation">
            <button className="nav-arrow nav-arrow-left" onClick={scrollLeft}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <button className="nav-arrow nav-arrow-right" onClick={scrollRight}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
        
        {/* Footer */}
        <div className="banner-footer">
          <p className="powered-by">2025 © Rajni Indian Restaurant. Powered by <span className="maghil-text"><a href="https://maghil.com" target="_blank" rel="noopener noreferrer"><img src={maghil} alt="Maghil" /></a></span></p>
        </div>
      </div>
    </section>
  );
};

export default Banner;
